<template>
  <div class="add-crew">
    <div class="d-flex justify-content-between align-items-center">
      <h2 class="title">Add Crew</h2>
      <div class="ico ico-close" @click="$emit('close-dashcard')">
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="16" cy="16" r="16" fill="#E4E6EB" />
          <g clip-path="url(#clip0)">
            <path
              d="M16.7855 16.0008L22.9482 9.83807C23.1652 9.6211 23.1652 9.26932 22.9482 9.05238C22.7312 8.83543 22.3794 8.83541 22.1625 9.05238L15.9998 15.2151L9.83709 9.05238C9.62012 8.83541 9.26834 8.83541 9.0514 9.05238C8.83446 9.26935 8.83443 9.62113 9.0514 9.83807L15.2141 16.0008L9.0514 22.1635C8.83443 22.3804 8.83443 22.7322 9.0514 22.9492C9.15987 23.0576 9.30207 23.1119 9.44426 23.1119C9.58646 23.1119 9.72862 23.0576 9.83712 22.9492L15.9998 16.7865L22.1625 22.9492C22.2709 23.0576 22.4131 23.1119 22.5553 23.1119C22.6975 23.1119 22.8397 23.0576 22.9482 22.9492C23.1652 22.7322 23.1652 22.3804 22.9482 22.1635L16.7855 16.0008Z"
              fill="#606770"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect
                width="14.2222"
                height="14.2222"
                fill="white"
                transform="translate(8.88867 8.88889)"
              />
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>
    <button @click="showAddPopup" class="btn btn-primary btn-sm collapsed">
      +Add New Crew
    </button>
    <div class="select_crew">
      or select an existing crew
    </div>
    <div class="crew-list">
      <div
        class="crew-member"
        v-for="(crew, n) in crews"
        :key="n"
        @click="toogleCrew(crew)"
        :class="{ active: activeCrew.indexOf(crew) >= 0 }"
      >
        <div class="info">
          <div>
            <h4 class="headline" v-if="crew.role">{{ crew.role }}</h4>

            <img v-if="crew.user.imgURL" :src="crew.user.imgURL" alt="" />
            <b-avatar v-else></b-avatar>

            <h3>
              {{ crew.nickname }}
              <br />
              <span v-if="crew.user.firstname"
                >({{ crew.user.firstname + " " + crew.user.lastname }})</span
              >
            </h3>
          </div>
        </div>
        <span
          class="ico"
          v-if="activeCrew.indexOf(crew) < 0"
          v-b-tooltip.hover
          title="Add Crew"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="12"
              cy="12"
              r="12"
              fill="var(--theme-color)"
              fill-opacity="0.1"
            />
            <path
              d="M12.0005 6V18.857"
              stroke="var(--theme-color)"
              stroke-width="2"
              stroke-linecap="round"
            />
            <path
              d="M5 12.4287L19 12.4287"
              stroke="var(--theme-color)"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </span>
        <span class="ico" v-else v-b-tooltip.hover title="Remove Crew">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="12"
              cy="12"
              r="12"
              fill="var(--theme-color)"
              fill-opacity="0.1"
            />
            <path
              d="M4 13.875L8.09091 18L19 7"
              stroke="var(--theme-color)"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </span>
      </div>
      <div class="footer">
        <button @click="closeAddCrew" class="btn btn-green btn-sm collapsed">
          Done
        </button>
      </div>
    </div>
    <AddCrewPopup
      @addCrew="addCrew"
      ptitle="Add Crew"
      v-if="show.addPopup"
    ></AddCrewPopup>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AddCrewPopup from "@/components/dashcard/components/AddCrewPopup";
export default {
  props: {
    addPopup: Boolean,
    currentCrews: Array
  },
  data() {
    return {
      show: {
        addPopup: this.addPopup
      },
      crews: [],
      activeCrew: []
    };
  },
  computed: {
    ...mapGetters({
      crewList: "user/listNames"
    })
  },
  components: {
    AddCrewPopup
  },
  watch: {
    addPopup(newval) {
      this.show.addPopup = newval;
    }
  },
  mounted() {
    // this.crewList.forEach(crew => {
    //   let crewmember = {
    //     name: crew.info.firstname + " " + crew.info.lastname,
    //     email: crew.info.email || ""
    //   };
    //   this.crews.unshift(crewmember);
    // });
    this.crewList.forEach(crew => {
      let crewmember = {
        uid: crew.uid,
        nickname: crew.info.nickname,
        role: crew.info.role
      };

      if (crew.user) {
        crewmember.user = {
          email: crew.user.email,
          firstname: crew.user.firstname,
          lastname: crew.user.lastname,
          imgURL: crew.user.imgURL,
          userId: crew.user.userId
        };
      }

      this.crews.unshift(crewmember);
    });
    this.currentCrews.forEach(crew => {
      this.activeCrew.push(crew);
    });
    console.log(this.crews);
    console.log(this.activeCrew);
    console.log(this.currentCrews);
  },
  methods: {
    toogleCrew(crew) {
      console.log(crew);
      let current_index = this.activeCrew.indexOf(crew);
      console.log(current_index);
      if (current_index >= 0) {
        this.activeCrew.splice(current_index, 1);
      } else {
        this.activeCrew.push(crew);
      }
      console.log(this.activeCrew);
      this.$emit("updateCrews", this.activeCrew);
    },
    addCrew(crew) {
      let uid = this.checkIsNameOnDb(crew.name);
      console.log("first naem", crew.nickname.split(" "));
      var name = crew.nickname.split(" ");
      let crewmember = {
        _created_at: new Date(),
        uid: uid === 0 || uid > -1 ? uid : undefined,
        nickname: crew.nickname,
        role: crew.role,
        user: {
          email: crew.email,
          firstname: name[0],
          lastname: name[name.length - 1],
          imgURL: null,
          userId: this.$store.getters["user/user"].uid
        }
      };
      this.crews.unshift(crewmember);
      this.activeCrew.push(crewmember);
      this.show.addPopup = false;
      this.addNewCrew(crewmember);
      this.$emit("toogleAddPopup");
    },
    addNewCrew(crewmember) {
      this.$store.dispatch("user/addNames", {
        names: [crewmember]
      });
    },
    showAddPopup() {
      this.$emit("toogleAddPopup");
      this.show.addPopup = true;
      // alert('showAddPopup', this.show.addPopup)
    },
    closeAddCrew() {
      this.$emit("closeAddCrew", this.activeCrew);
    },
    checkIsNameOnDb(name) {
      let existingNames = this.$store.getters["user/listNames"].map(
        el =>
          `${el.info.firstname +
            (el.info.lastname ? " " + el.info.lastname : "")}`
      );
      if (existingNames.includes(name)) {
        return this.$store.getters["user/listNames"][
          existingNames.indexOf(name)
        ].uid;
      } else {
        return false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.ico {
  cursor: pointer;
}
.add-crew {
  padding: 24px;
  //position: relative;
  .title {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 22px;
    color: #474d52;
    margin: 0;
  }
  .btn.collapsed {
    padding: 11px;
    width: 100%;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 22px;
    color: #ffffff;
    border-radius: 8px;
    margin-top: 23px;
  }
  .select_crew {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    color: #8d99a0;
    text-align: center;
    margin-top: 16px;
  }
  .crew-list {
    margin-top: 16px;
    //position: relative;
    padding: 0 8px 24px 24px;
    max-height: 70vh;
    overflow-y: scroll;
    margin-right: 8px;
    &::-webkit-scrollbar {
      height: 0px;
      width: 8px;
      margin-right: 10px;
    }

    &::-webkit-scrollbar-track {
      background-color: #fff;
      // width: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: #dddddd;
      border-radius: 16px;
      // width: 4px !important;
    }
    .footer {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      box-shadow: 0px -4px 12px rgba(0, 0, 0, 0.08);
      display: flex;
      justify-content: center;
      align-items: center;
      .btn-green {
        background-color: #65ea82;
        max-width: 80%;
        margin-top: 12px;
        margin-bottom: 12px;
      }
    }
    .crew-member {
      margin-bottom: 4px;
      border-radius: 8px;
      cursor: pointer;
      position: relative;
      &.active {
        background: rgba(85, 126, 251, 0.1);
      }
      .ico {
        position: absolute;
        top: 66%;
        right: 20px;
        transform: translateY(-50%);
        cursor: pointer;
      }
      .headline {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        color: #8d99a0;
        margin-bottom: 10px;
      }
      .info {
        padding: 8px 16px;
        display: grid;
        grid-template-columns: 1fr 25px;
        align-items: center;
        img {
          width: 40px;
          height: 40px;
          object-fit: cover;
          border-radius: 50%;
          margin-top: -20px;
        }
        h3 {
          font-style: normal;
          font-weight: normal;
          font-size: 16px;
          line-height: 22px;
          color: #474d52;
          margin: 0 0 0 10px;
          display: inline-block;
        }
        span {
          font-weight: bold;
          font-size: 12px;
        }
        .ico {
          cursor: pointer;
          //   display: none;
          //   transition: all 0.4s linear;
        }
      }
    }
  }
  .add-crew-popup {
    width: 328px;
    height: 307px;
    position: absolute;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    border-radius: 10px;
    background-color: #fff;
    top: 13%;
    right: 0;
    padding: 24px 16px;
    z-index: 3;
    .title {
      font-weight: normal;
      font-size: 16px;
      line-height: 22px;
    }
  }
}
</style>
